module.exports = __webpack_public_path__ + "img/add-arrival-canceled-table-icon.a14c21a6.svg";